import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LorenNotificationsPanelComponent} from './components/loren-notifications-panel/loren-notifications-panel.component';

const routes: Routes = [
    {
        path: '',
        component: LorenNotificationsPanelComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LorenNotificationPanelRoutingModule {
}
